/**
 * Fetch wrapper: cookies on every call, CSRF echoed on mutations, and a 401
 * bounce to sign-in that preserves where the user was.
 */

const csrf = () =>
  document.cookie.split("; ").find((c) => c.startsWith("fhp_csrf="))?.split("=")[1] ?? "";

async function call(method: string, path: string, body?: unknown) {
  const res = await fetch(path, {
    method,
    credentials: "include",
    headers: {
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      ...(method === "GET" ? {} : { "X-CSRF-Token": csrf() }),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    window.location.href = `/api/auth/login?next=${encodeURIComponent(location.pathname)}`;
    throw new Error("redirecting to sign-in");
  }
  if (!res.ok) {
    let msg = `${res.status}`;
    try { msg = (await res.json()).error ?? msg; } catch { /* keep the status */ }
    throw new Error(msg);
  }
  return res.status === 204 ? null : res.json();
}

export const api = {
  get: (p: string) => call("GET", p),
  post: (p: string, b?: unknown) => call("POST", p, b ?? {}),
  del: (p: string) => call("DELETE", p),
};
